import { Box, Button, Link, Typography } from '@mui/material';
import './RemoveUserConfirmation.scss';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

export const RemoveUserConfirmation = ({
  onClose,
  order,
  error,
  removeSubmission
}) => {
  const { t } = useTranslation();
  //removeUserConfirmationContainer
  //removeUserConfirmationBody
  return (
    <Box className="editUserCardPopupContainer removeUserConfirmationContainer">
      <Box className="editUserCardPopupBody removeUserConfirmationBody">
        <Typography sx={{ fontWeight: '600', fontSize: '16px' }}>
          {t('sellerProfile.dashboard.confirmRemove')}
        </Typography>
        <Box className="removeUserConfirmationButtons ">
          <Link
            onClick={() => onClose(false)}
            onKeyDown={(e) => e.key === 'Enter' && onClose(false)}
            className="cancelButton"
            tabIndex={0}
          >
            {t('sellerProfile.dashboard.cancel')}
          </Link>

          {removeSubmission ? (
            <LoadingButton
              loading
              variant="secondary"
              size="md"
              sx={{
                '@media(max-width: 900px)': {
                  width: '100%'
                }
              }}
              // className="removeUserButton loading"
            >
              {' '}
              {t('sellerProfile.dashboard.removeUser')}
            </LoadingButton>
          ) : (
            <Button
              variant="secondary"
              size="md"
              onClick={() => onClose(true)}
              onKeyDown={(e) => e.key === 'Enter' && onClose(true)}
              sx={{
                '@media(max-width: 900px)': {
                  width: '100%'
                }
              }}
            >
              {t('sellerProfile.dashboard.removeUser')}
            </Button>
          )}
        </Box>
        {error !== '' && (
          <Box
            sx={{
              marginTop: '12px',
              fontWeight: 'bold',
              color: '#D8292F',
              width: 'auto',
              maxWidth: '300px',
              textAlign: 'center'
            }}
          >
            {error}
          </Box>
        )}
      </Box>
    </Box>
  );
};
